module.exports = __webpack_public_path__ + "static/media/js-logo.69b4d957.png";